import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@material-ui/core';
import * as FontAwesome from '@fortawesome/react-fontawesome';
import { InputCpf, InputPassword } from 'components';
import { Form, Row, Col } from 'react-bootstrap';
import Alert from '@material-ui/lab/Alert';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import sha1 from 'sha1';
import { login } from "services/ducks/auth";
import apiLogin from "services/structure/apiLogin";

class LoginPanel extends Component {
    
    state = {
        documento: "",
        senha: "",
        error: ""
    };

    config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
    }

    handleLogin = async e => {
        this.setState({ error : "" });
        e.preventDefault();
        const { documento, senha } = this.state;
        if (!documento || !senha) {
            this.setState({ error: "Preencha CPF e senha para continuar!" });
        } else {
            try {
                const response = await apiLogin.post("/login/ap20", `documento=${encodeURI(btoa(documento))}&senha=${encodeURI(sha1(senha))}`);
                this.props.login(response.data);
                this.props.history.push("/app/");
            } catch (err) {
                const mensagem = err.response?.data?.message ?? "Houve um problema com o login, verifique suas credenciais. " ;
                this.setState({error: mensagem});
            }
        }
    };

    render() {
        return (
                <Form onSubmit={this.handleLogin} className={`login-form ${this.props.className}`}>
                    <InputCpf 
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Digite seu CPF"
                        name="documento"
                        onChange={e => this.setState({ documento: e.target.value })}
                        error={!!this.state.error}/>
                    <InputPassword
                        name="senha"
                        label="Digite sua senha"
                        autoComplete="off" 
                        onChange={e => this.setState({ senha: e.target.value })}
                        error={!!this.state.error}/>
                        {
                            !!this.state.error &&
                            <Alert severity="error"><p>{this.state.error}</p></Alert>
                        }
                    <Row>
                        <Col sm={12}>
                            <Button type="submit" fullWidth className={`button login-button ${this.props.className}`} variant="contained">
                                <FontAwesome.FontAwesomeIcon icon={faUser}  className={`login-button-icon ${this.props.className}`}/> 
                                <span  className={`login-button-label ${this.props.className}`}>ENTRAR</span>
                            </Button>
                        </Col>
                    </Row>
                </Form>
        )
    }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ login }, dispatch);

export default connect(null, mapDispatchToProps) (withRouter(LoginPanel));